import React from "react";
import { FormTemplate } from "./templates";

class UpdatePositionModal extends FormTemplate {
    sendRequest = () => {
        const { optionId, data, updatePoint } = this.props;
        return updatePoint(data, optionId).then(() => this.close(true));
    };

    renderBodyInner = () => {
        return <div className="modal-window__body">{this.props.text}</div>;
    };
}

const ConfiguredModal = (props) => <UpdatePositionModal {...props} config={{}} />;

export default ConfiguredModal;
